import { BonhamsChannel } from '@nx/external/pusher'

export const userChannelVersion = 1

export const buildUserChannelName = (customerId: number): BonhamsChannel =>
  `user-${customerId}-v${userChannelVersion}`
